module.exports = __webpack_public_path__ + "static/media/blog_img7.14f3f793.jpg";